export function getPaymentType() {
  if (typeof localStorage === 'undefined') return 'paytm';
  return (localStorage.getItem('payment_type') || 'paytm').toLowerCase();
}

export function isInternationalPayment() {
  return getPaymentType() === 'stripe';
}

export function isSubscriptionProduct(product = {}) {
  return Number(product.subscription_price ?? 0) > 0
    || Number(product.subscription_price_usd ?? 0) > 0;
}

export function getMoneyFields(product = {}, { discountedPrice = null, couponStatus = 'idle' } = {}) {
  const international = isInternationalPayment();
  const symbol = international ? '$' : '₹';
  const offerKey = international ? 'offer_price_usd' : 'offer_price';
  const originalKey = international ? 'original_price_usd' : 'original_price';
  const subscriptionKey = international ? 'subscription_price_usd' : 'subscription_price';
  const fallbackOffer = product.offer_price ?? 0;

  const basePrice = product[offerKey] ?? fallbackOffer;
  const finalPrice = couponStatus === 'applied' && discountedPrice !== null
    ? discountedPrice
    : basePrice;

  return {
    symbol,
    isInternational: international,
    finalPrice,
    offerPrice: basePrice,
    originalPrice: product[originalKey] ?? null,
    subscriptionPrice: product[subscriptionKey] ?? 0,
  };
}

export function formatMoney(value, symbol = '₹') {
  if (value === null || value === undefined || value === '') return `${symbol}0`;
  const numeric = Number(value);
  const display = Number.isFinite(numeric)
    ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(numeric)
    : String(value);
  return `${symbol}${display}`;
}
